var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobalProvide1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeWidth: 1.5,
  d: "M9.333 7.75a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeWidth: 2,
  d: "M3.84 13.333H28a4 4 0 0 1 4 4v1.334H4.16a2.827 2.827 0 0 1-2.827-2.827 2.507 2.507 0 0 1 2.507-2.507Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeWidth: 2,
  d: "M1.333 16v18.667a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-12a4 4 0 0 0-4-4H4.667"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#408BFC",
  strokeWidth: 1.5,
  d: "M26 15.917c0 .85-.151 1.664-.428 2.416H12.428A7 7 0 1 1 26 15.916Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#408BFC",
  d: "M33.583 31.25v-5.333a1.333 1.333 0 0 0-2.666 0v5.333a1.333 1.333 0 1 0 2.666 0"
})));
export default SvgGlobalProvide1;